/* eslint-disable @typescript-eslint/naming-convention */
import runtimeEnv from '@mars/heroku-js-runtime-env'
import { env } from '../../../env'

const {
  REACT_APP_API_URL,
  REACT_APP_AZURE_STORAGE_URL,
  REACT_APP_ONSCHED_LOCATION_ID,
  REACT_APP_ONSCHED_CLIENT_ID,
  REACT_APP_ONSCHED_ENV,
  REACT_APP_SSO_CLIENT_ID,
  REACT_APP_SSO_TENANT_ID,
} = runtimeEnv()

export const apiRootUrl = REACT_APP_API_URL || env.REACT_APP_API_URL
export const AZURE_STORAGE_URL =
  REACT_APP_AZURE_STORAGE_URL || env.REACT_APP_AZURE_STORAGE_URL
export const ONSCHED_LOCATION_ID =
  REACT_APP_ONSCHED_LOCATION_ID || env.REACT_APP_ONSCHED_LOCATION_ID
export const ONSCHED_CLIENT_ID =
  REACT_APP_ONSCHED_CLIENT_ID || env.REACT_APP_ONSCHED_CLIENT_ID
export const ONSCHED_ENV = REACT_APP_ONSCHED_ENV || env.REACT_APP_ONSCHED_ENV
export const SSO_CLIENT_ID =
  REACT_APP_SSO_CLIENT_ID || env.REACT_APP_SSO_CLIENT_ID
export const SSO_TENANT_ID =
  REACT_APP_SSO_TENANT_ID || env.REACT_APP_SSO_TENANT_ID

// RTK Query
export const signInUrl = '/admin/login'
export const logoutUrl = '/admin/logout'
export const clientUrl = '/admin/client'
export const clientsUrl = '/admin/clients'
export const productUrl = '/admin/product'
export const membersUrl = 'admin/member/handlecsv'
export const memberResetPasswordLinkUrl = 'admin/member/forgotpassword'
export const membersListUrl = '/admin/member/list'
export const memberDetailsUrl = '/admin/member/view'
export const changeStatusUrl = '/admin/member/changestatus'
export const activateMemberUrl = '/admin/member/unlock'
export const deleteMemberUrl = '/admin/member/delete'
export const memberBookingListUrl = '/admin/member/list/booking'
export const memberBookingUrl = '/admin/member/view/booking'
export const memberStoreBookingUrl = '/admin/member/store/booking'
export const fileUrl = '/admin/file'
export const forgotPasswordUrl = '/admin/forgot-password'
export const resetPasswordUrl = '/admin/reset-password'
export const memberProfileStatusUrl = '/admin/member/profile/status'
export const memberFFQDetailsUrl = '/admin/member/ffq'
export const helpPagesUrl = '/member/pages'
export const newsPagesUrl = '/member'
export const newsCenterUrl = ''
